const styles = [
  {
    featureType: 'all',
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#000000',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#000000',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'all',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text',
    stylers: [
      {
        color: '#00467f',
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#edf9fd',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#00a3e1',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ecfafe',
      },
      {
        lightness: 20,
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'labels.text',
    stylers: [
      {
        color: '#00467f',
      },
    ],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#66caf0',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        color: '#00a3e1',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#b7e4ef',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#a3dcea',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [
      {
        color: '#00467f',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        lightness: 17,
      },
      {
        saturation: '100',
      },
      {
        color: '#00467f',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#b7e4ef',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#8cd4e3',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#b7e4ef',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#8cd4e3',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#000000',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#00467f',
      },
    ],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#00a3e1',
      },
    ],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#00a3e1',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#00a3e1',
      },
    ],
  },
];

window.initMap = function () {
  // activate main map
  if (typeof mapPosition !== 'undefined' && mapPosition) {
    const zoom = 16;

    const map = new google.maps.Map(document.getElementById('map'), {
      center: mapPosition,
      zoom,
      disableDefaultUI: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    map.setOptions({ styles });

    const customMarker = new google.maps.MarkerImage(
      '/images/pin.svg',
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      new google.maps.Point(
        30,
        60
      ) /* anchor is bottom center of the scaled image */,
      new google.maps.Size(60, 60) /* Size given in CSS Length units */
    );

    // eslint-disable-next-line no-unused-vars
    const marker = new google.maps.Marker({
      position: mapPosition,
      map,
      icon: customMarker,
    });
  }

  // activate mini maps
  const maps = document.querySelectorAll('[data-map]');
  maps.forEach((el) => {
    const lat = parseFloat(el.getAttribute('data-lat'));
    const lng = parseFloat(el.getAttribute('data-lng'));
    const mapPosition = {
      lat,
      lng,
    };

    const zoom = 14;

    const map = new google.maps.Map(el, {
      center: mapPosition,
      zoom,
      disableDefaultUI: true,
      scrollwheel: false,
      navigationControl: true,
      mapTypeControl: false,
      scaleControl: true,
      draggable: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      zoomControl: true,
    });

    map.setOptions({ styles });

    const customMarker = new google.maps.MarkerImage(
      '/images/map-pin.svg',
      null /* size is determined at runtime */,
      null /* origin is 0,0 */,
      new google.maps.Point(
        45 / 2,
        67
      ) /* anchor is bottom center of the scaled image */,
      new google.maps.Size(45, 67) /* Size given in CSS Length units */
    );

    // eslint-disable-next-line no-unused-vars
    const marker = new google.maps.Marker({
      position: mapPosition,
      map,
      icon: customMarker,
    });
  });
};
